export const Views = ['mpc', 'avvik'];

export const ViewIndex = {
    mpc: 0,
    avvik: 1
};

export function getViewName(viewIndex) {
    if (!viewIndex) return Views[ViewIndex.mpc];
    return viewIndex === ViewIndex.avvik ? 'avvik' : 'mpc';
}

export function getViewIndex(view) {
    if (!view) return ViewIndex.mpc;
    return view === Views[ViewIndex.avvik] ? ViewIndex.avvik : ViewIndex.mpc;
}
